/// <reference types="node"/>
import * as querystring from 'querystring';
import { Brand, getURLs, LalaSentry } from '.';
import { Type } from './Type';
import { validateReturnURLByMap } from './validateReturnURL';
var generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnUrlParam = urlQueries.returnURL || '';
    var returnURL = validateReturnURLByMap(returnURLs, returnUrlParam) ? returnUrlParam : returnURLs.authenticated;
    if (stringQueries === '')
        return returnURL;
    if (returnURL.includes('?'))
        return "".concat(returnURL, "&").concat(stringQueries);
    return "".concat(returnURL, "?").concat(stringQueries);
}; };
export var getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    if (brand === Brand.Domain && type === Type.Customer) {
        return generateDomainReturnURL(returnURL, returnURLs);
    }
    else {
        var generateReturnURL = generateReturnURLHOF(returnURLs);
        return generateReturnURL(returnURL);
    }
};
// https://creditandfinance.atlassian.net/browse/SUB-2202
var generateDomainReturnURL = function (urlQueries, returnURLs) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnURLObject = urlQueries.returnURL || '';
    if (returnURLObject) {
        if (stringQueries === '') {
            // with no query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL);
        }
        else {
            // with query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL, "&").concat(stringQueries);
        }
    }
    else {
        // when there is no return url given
        return "".concat(returnURLs.authenticated);
    }
};
export var executeReturnURL = function (brand, type, env, returnURL) {
    var returnUrl = getReturnURLFromLALAURLQueries(brand, type, env, returnURL);
    LalaSentry.logInfo('redirect by executeReturnURL', { returnUrl: returnUrl });
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map